<div  *ngIf="showmenu"><button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Icon-button with a menu">
    <mat-icon>menu</mat-icon>
  </button>
   <mat-menu #menu="matMenu">
    <button mat-menu-item (click)="menu_participant()">Before the race - Manage Particpants</button>

 
    <button mat-menu-item [matMenuTriggerFor]="start" *ngIf="mass_start_array.length>0">At the start - Mass Starts</button>

   
    <button mat-menu-item *ngIf="has_individual_start" (click)="menu_timing_point('Individual Start')">At the start - Individual Starts</button>


    <button mat-menu-item [matMenuTriggerFor]="checkpoint" *ngIf="checkpoint_array.length>0">During the race - Checkpoint</button>

  
    <button mat-menu-item (click)="menu_timing_point('Finish Line')">At the end - Finish Line</button>

    <mat-divider></mat-divider>
    <button mat-menu-item (click)="usermanual()">User Manual</button>
    
    <mat-divider></mat-divider>
    <button mat-menu-item (click)="logout()">Log Out</button>
  </mat-menu>
  
  <mat-menu #start="matMenu">
    <button mat-menu-item  (click)="menu_mass_start(mass_start.key, mass_start.value)" *ngFor="let mass_start of mass_start_array | keyvalue">{{ mass_start.value }}</button>
  </mat-menu>
  
  <mat-menu #checkpoint="matMenu">
    <button mat-menu-item *ngFor="let checkpoint of checkpoint_array" (click)="menu_timing_point(checkpoint)">{{ checkpoint }}</button>
  </mat-menu>
</div>
